import api from './api'

export default {
  download(param) {
    return api.get('documents/download',{params:param})
  },
 
}
